import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ExcStateSecurityProcessor} from 'exc-security-v2';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ReceiptListComponent} from './receipt/receipt-list.component';
import {TaskListComponent} from './task/task-list/task-list.component';
import {CaseListComponent} from './case/case-list/case-list.component';
import {CompanyListComponent} from './company/company-list.component';
import {HomeComponent} from './home/home.component';
import {MessageListComponent} from './message/message-list/message-list.component';
import {ScheduleListComponent} from './schedule/schedule-list/schedule-list.component';
import {ReportListComponent} from './report/report-list/report-list.component';
import {UserListComponent} from './user/user-list/user-list.component';
import {RedirectComponent} from './redirect/redirect.component';
import {LibraryComponent} from './library/library.component';
import {SettingsMainComponent} from './settings/settings-main/settings-main.component';
import {OeListComponent} from './oe/oe-list.component';
import {QuestionnaireEditorComponent} from './Questionnaire/questionnaire-editor/questionnaire-editor.component';
import {DispositionList2Component} from './disposition/disposition-list2/disposition-list2.component';
import {ExgPhotoDocumentationComponent} from './misc/exg-photo-documentation/exg-photo-documentation.component';
import {CalculationSpreadsheetComponent} from './Calculation/calculation-spreadsheet/calculation-spreadsheet.component';
import {ReceiptStatementListComponent} from './receipt-statement/receipt-statement-list.component';
import {LeistungserfassungListComponent} from './leistungserfassung/leistungserfassung-list.component';

const routes: Routes = [
  {
    path: '', redirectTo: '/home', pathMatch: 'full',
    data: {hidden: true}
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-home', friendlyName: 'Home', security: '*', Caption: 'Home'}
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-tachometer-fast', friendlyName: 'Dashboard', security: 'DASHNAV', Caption: 'Dashboard'}
  },
  {
    path: 'caselist',
    component: CaseListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-folders', friendlyName: 'Auftragsliste', security: 'CASENAV', Caption: 'Auftrag', appTabbable: true}
  },
  {
    path: 'tasklist',
    component: TaskListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-clipboard-list', friendlyName: 'Vorgangsliste', security: 'TASKNAV', Caption: 'Vorgang', appTabbable: true}
  },
  {
    path: 'messagelist',
    component: MessageListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {
      class: 'fa-light fa-mail-bulk',
      friendlyName: 'Nachrichtenliste',
      security: 'MSGNAV',
      Caption: 'Nachrichten',
      appTabbable: true
    }
  },
  // {
  //   path: 'todolist',
  //   component: TodoListComponent,
  //   canActivate: [ExcStateSecurityProcessor],
  //   data: {class: 'fa-light fa-check', friendlyName: 'Aufgabenliste', security: 'TODONAV', Caption: 'Aufgaben', appTabbable: true}
  // },
  {
    path: 'schedulelist',
    component: ScheduleListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {
      class: 'fa-light fa-calendar-check',
      friendlyName: 'Ablaufplanliste',
      security: 'SCHEDULENAV',
      Caption: 'Ablaufplan', appTabbable: true,
    }
  },
  {
    path: 'leistungserfassung',
    component: RedirectComponent,
    canActivate: [ExcStateSecurityProcessor],
    resolve: {
      url: 'externalUrlRedirectResolver'
    },
    data: {
      class: 'fa-light fa-euro-sign',
      friendlyName: 'Berichtsliste',
      security: 'LERFNAV',
      Caption: 'Leistungserf..',
      externalUrl: 'https://www.myexcon.com/leistungserfassung'
    }
  },
  {
    path: 'leistungserfassungv2',
    component: LeistungserfassungListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {
      class: 'fa-light fa-euro-sign',
      friendlyName: 'LE WIP',
      security: 'DEVELOPMENT', // war LERFNAV
      Caption: 'LE WIP',
      appTabbable: true
    }
  },
  {
    path: 'reportlist',
    component: ReportListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-file-check', friendlyName: 'Berichtsliste', security: 'REPORTNAV', Caption: 'Bericht', appTabbable: true}
  },
  {
    path: 'receiptlist',
    component: ReceiptListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {
      class: 'fa-light fa-file-invoice-dollar'
      , friendlyName: 'Belegliste'
      , security: 'RECEIPTNAV'
      , Caption: 'Beleg'
      , appTabbable: true
    }
  },
  {
    path: 'statementlist',
    component: ReceiptStatementListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {
      class: 'fa-light fa-file-lines'
      , friendlyName: 'Stellungnahmeliste'
      , security: 'STATEMENTNAV'
      , Caption: 'Stellungnah..'
      , appTabbable: true
    }
  },
  {
    path: 'companylist',
    component: CompanyListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-building', friendlyName: 'Aussteller', security: 'COMPANYNAV', Caption: 'Aussteller', appTabbable: true}
  },
  {
    path: 'dispositionlist',
    component: DispositionList2Component,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-map', friendlyName: 'Disposition', security: 'DISPONAV', Caption: 'Dispo', appTabbable: true}
  },
  {
    path: 'userlist',
    component: UserListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-user', friendlyName: 'Benutzerliste', security: 'USERNAV', Caption: 'Benutzer', appTabbable: true}
  },
  {
    path: 'library',
    component: LibraryComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-book', friendlyName: 'Bibliothek', security: 'LIBNAV', Caption: 'Bibliothek', appTabbable: true}
  },
  {
    path: 'crm',
    component: OeListComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-sitemap', friendlyName: 'CRM', security: 'CRMNAV', Caption: 'CRM', appTabbable: true}
  },
  {
    path: 'settings',
    component: SettingsMainComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-wrench', friendlyName: 'Einstellungen', security: 'SETTINGSNAV', Caption: 'Einstellungen', appTabbable: true}
  },
  {
    path: 'editor',
    component: QuestionnaireEditorComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-space-station-moon', friendlyName: 'Editor', security: 'QUESTCNFEDIT', Caption: 'Editor', appTabbable: true}
  },
  {
    path: 'demo',
    component: ExgPhotoDocumentationComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-portal', friendlyName: 'Demo', security: 'DEVELOPMENT', Caption: 'Demo', appTabbable: false}
  },
  {
    path: 'spread',
    component: CalculationSpreadsheetComponent,
    canActivate: [ExcStateSecurityProcessor],
    data: {class: 'fa-light fa-spreadsheet', friendlyName: 'Spread', security: 'DEVELOPMENT', Caption: 'Spread', appTabbable: false}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
